import { caseStudies } from '@/mocks/caseStudies';

export default function CaseStudiesSection() {
  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-14">
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 tracking-tight">
            Real-World Mulebuy Spreadsheet Workflow
          </h2>
          <p className="text-foreground-500 text-base md:text-lg mt-4 max-w-2xl mx-auto">
            Illustrative case studies showing how users interact with a Mulebuy spreadsheet system
          </p>
        </div>

        <div className="space-y-10">
          {caseStudies.map((cs) => (
            <div key={cs.id} className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/70">
              <div className="mb-6">
                <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
                  Case Study #{cs.id} — {cs.title}
                </h3>
                <p className="text-sm text-foreground-500 mt-1">
                  <strong className="text-foreground-700">User Profile:</strong> {cs.profile}
                  &nbsp;&nbsp;|&nbsp;&nbsp;
                  <strong className="text-foreground-700">Goal:</strong> {cs.goal}
                </p>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b border-background-200">
                      <th className="text-left py-3 px-4 font-semibold text-foreground-700">Stage</th>
                      <th className="text-left py-3 px-4 font-semibold text-foreground-700">Before Spreadsheet</th>
                      <th className="text-left py-3 px-4 font-semibold text-foreground-700">After Mulebuy Spreadsheet</th>
                    </tr>
                  </thead>
                  <tbody>
                    {cs.beforeItems.map((before, i) => (
                      <tr key={i} className="border-b border-background-100">
                        <td className="py-3 px-4 text-foreground-500">{cs.stages[i] || `Metric ${i + 1}`}</td>
                        <td className="py-3 px-4 text-foreground-600">{before}</td>
                        <td className="py-3 px-4 text-primary-700 font-medium">{cs.afterItems[i]}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="mt-5 p-4 bg-primary-50 rounded-lg border border-primary-100">
                <p className="text-sm text-primary-800">
                  <strong>Outcome Insight:</strong> {cs.outcomeText}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}